<script setup lang="ts">
import { researchStatus } from '@/enums/researchStatus';
interface Props {
  status: researchStatus
  isDeleted?: boolean
}

const props = withDefaults(defineProps<Props>(),{isDeleted: false})
</script>
<template>
  <div
    v-if="!isDeleted && props.status === researchStatus.REQUEST"
    class="w-[86px] rounded-[100px] bg-[--algo-system-yellow-100] flex justify-center items-center px-[8px] py-[6px] text-[--algo-system-yellow-600]"
  >
    Request
  </div>
  <div
    v-if="!isDeleted && props.status === researchStatus.APPROVED"
    class="w-[86px] rounded-[100px] bg-[--algo-system-green-100] flex justify-center items-center px-[8px] py-[6px] text-[--algo-system-green-600]"
  >
    Approved
  </div>
  <div
    v-if="!isDeleted && props.status === researchStatus.REVISION"
    class="w-[86px] rounded-[100px] bg-[--algo-system-blue-100] flex justify-center items-center px-[8px] py-[6px] text-[--algo-system-blue-600]"
  >
    Revision
  </div>
  <div
    v-if="!isDeleted && props.status === researchStatus.REJECTED"
    class="w-[86px] rounded-[100px] bg-[--algo-system-red-100] flex justify-center items-center px-[8px] py-[6px] text-[--algo-system-red-600]"
  >
    Rejected
  </div>
  <div
    v-if="!isDeleted && props.status === researchStatus.DRAFT"
    class="w-[86px] rounded-[100px] bg-[--algo-accent-slate-100] border border-[--algo-accent-slate-400] flex justify-center items-center px-[8px] py-[6px] text-[--algo-text-primary]"
  >
    Draft
  </div>
  <div
    v-if="isDeleted && (props.status === researchStatus.REJECTED ||  props.status === researchStatus.APPROVED)"
    class="w-[110px] rounded-[100px] bg-[--algo-system-red-100] flex justify-center items-center px-[8px] py-[6px] text-[--algo-system-red-600]"
  >
    Taken Down
  </div>
</template>
